import { render, staticRenderFns } from "./DoacoesDetalhadas.vue?vue&type=template&id=0b83f135"
import script from "./DoacoesDetalhadas.vue?vue&type=script&lang=js"
export * from "./DoacoesDetalhadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports